import Vue from 'vue'
import Vuex from 'vuex'
// import http from '../plugins/http'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        app: {
            version: '',
        },
        username: '',
        routerHistory: [],
        messages: [],
        permission: {},
        year: '2025',
    },
    mutations: {
        set_permission(state, data) {
            state.permission = data
        },
        set_version(state, data) {
            state.app.version = data.version
        },
        set_username(state, username) {
            localStorage.setItem('username', username)
            state.username = username
        },
        set_token(state, token) {
            localStorage.setItem('token', token)
            state.token = token
        },
        set_year(state, year) {
            state.year = year
            localStorage.setItem('year', year)
        },
        setRouterHistory(state, data) {
            let exist = false
            state.routerHistory.forEach(item=>{
                if(item.path===data.path){
                    exist = true
                }
            })
            if (!exist) {
                state.routerHistory.unshift(data)
            }
            let max = 5
            if (state.routerHistory.length > max) {
                state.routerHistory = state.routerHistory.slice(0, max)
            }
        },
        delRouterHistory(state, index) {
            state.routerHistory.splice(index, 1)
        },
    },
    getters: {
        username: state => {
            return state.username || localStorage.getItem('username')
        },
        token: state => {
            return state.token || localStorage.getItem('token')
        },
        year: state => {
            return state.year || localStorage.getItem('year') || '2025'
        },
        permission: state => {
            return state.permission
        }
    },
    actions: {
        // eslint-disable-next-line no-unused-vars
        getVersion: ({commit}) => {
            // http.get('/version').then(resp => {
            //     commit('set_version', resp.data)
            // })
        },
        // eslint-disable-next-line no-unused-vars
        login: ({commit}, data) => {
            // return new Promise((resolve, reject) => {
            //     http.post(`/auth/login`, data)
            //         .then(function (res) {
            //             if (res.data.code == 200) {
            //                 commit('set_username', data.username)
            //                 commit('set_token', res.data.data.token)
            //             }
            //             resolve(res.data)
            //         })
            //         .catch((e) => {
            //             reject(e)
            //         })
            // })
        }
    }
})

export default store
